import { atom } from "jotai";
import { ProductCardProps } from "app/components/Product/ProductCard";

export const productPreviewAtom = atom<ProductCardProps | null>(null);
export const isProductPreviewOpen = atom<boolean>(false);

export const productAtom = atom(null);